/**
 * Service for creating and managing share links
 */
export interface ShareLinkService {
    /**
     * Create a share link for a given task
     *
     * @param password - Optional password for protected sharing
     * @returns Promise resolving to the share ID
     * @throws Error if the share link creation fails
     */
    createShareLink(password?: string): Promise<string>;
}

/**
 * Symbol for dependency injection of ShareLinkService
 */
export const ShareLinkService = Symbol.for('ShareLinkService');
